import React from "react";
import { Link } from "react-router-dom";

const Banner = ({ scrollToDiv, el1 }) => {
  return (
    <>
      <section className="HireDeveloperHero">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-5 col-lg-6 col-md-6 mb-5 mb-lg-0 pr-lg-5 pr-xl-0">
              <div className="heading">
                <h1 className="mb-5">
                  Hire The Top Skilled Resources. Destination To Get The Best{" "}
                  <span>Dedicated Developers Remotely!</span>
                </h1>
                <p className="text-justify">
                  When we think about managing the deliverables, we usually
                  always thought to map resources with a timeline. Here we
                  require to bridge the gap if any with external experts who are
                  always ready to work dedicatedly and remotely. We work with
                  the basis of “You name it, we have it” as far as skills,
                  technology, and expertise is concerned.
                </p>
                <Link to="/HireDeveloper" className="btn">
                  <span>Hire Top Developers</span>
                </Link>
                <a className="btn contactBtn" onClick={() => scrollToDiv(el1)}>
                  <span>Contact Now</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Banner;
